import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultKSK2021_R01Filter, KSK2021_R01Filter, useKSK2021_R01Store } from './Store_KSK2021_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { downloadExcel_KSK2021_R01, getKSK2021_R01AllCount, getKSK2021_R01InspectList, getKSK2021_R01List, getKSK2021_R01ProductResultList, patchKSK2021_R01, postKSK2021_R01, printKSK2021_R01, getKSK2021_R01DetailList, getKSK2021_R01DetailStockList, getKSK2021_R01TransportedInfo, getKSK2021_R01One, patchKSK2021_R01WorkStart, patchKSK2021_R01WorkEnd } from "./Api_KSK2021_R01";
import { defaultKSK2021_R01HeaderDto, defaultKSK2021_R01InspectDto, KSK2021_R01Dto, KSK2021_R01HeaderDto, KSK2021_R01InspectDto, KSK2021_R01ProductResultDto, defaultKSK2021_R01DetailDto, KSK2021_R01DetailDto, KSK2021_R01WorkTimeProcessType, } from './Dto_KSK2021_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
	KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
	KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
	KSK2021_R01_HEADER_ROW_VALIDATE,
	KSK2021_R01_INSPECT_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { defaultValidateDateString, inkoNpmOption } from 'src/components/common/common';
import { AxiosError } from 'axios';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { getProductWorkList } from 'src/apis/productWorkApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { ItemLabelPrintData } from 'src/apis/itemLabelApi';
import { useItemQzPrint } from 'src/hooks/useItemQzPrint';
import { KSK2021_R01_extractUnprintedItemLabelData } from './labelDataBuilder_KSK2021_R01';
import { aggregateKSK2021_R01DetailList, findAggregatedDetailItem, normalizeKSK2021_R01DetailList } from './Util_KSK2021_R01';
import useUserStore from 'src/store/useUserStore';

interface Props {
	gridRef: React.RefObject<AgGridReact<KSK2021_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK2021_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<KSK2021_R01InspectDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_KSK2021_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef, inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { downtimeValueList, faultyValueList, itemStatusList, moneyCdList, vatTypeList, compCdList, wmsCdList, employeeCdList, workPlaceList, warehouseCdList, itemCdMap } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { productWorkNavigationData, setProductWorkNavigationData, setOrderNavigationData, addTabList, setActiveTab } = useUiuxStore();

	
	const {
		KSK2021_R01Filter, setKSK2021_R01Filter,
		KSK2021_R01PastFilter, setKSK2021_R01PastFilter,
		KSK2021_R01List, setKSK2021_R01List,
		editKSK2021_R01, setEditKSK2021_R01,
		deletedKSK2021_R01DetailList, setDeletedKSK2021_R01DetailList, addDeletedKSK2021_R01DetailList, removeDeletedKSK2021_R01DetailList, 
		selectedKSK2021_R01DetailList, setSelectedKSK2021_R01DetailList, addSelectedKSK2021_R01DetailList, removeSelectedKSK2021_R01DetailList,
		KSK2021_R01DetailList, setKSK2021_R01DetailList, insertKSK2021_R01DetailList,
		originalKSK2021_R01DetailList, setOriginalKSK2021_R01DetailList,
		KSK2021_R01InspectList, setKSK2021_R01InspectList, insertKSK2021_R01InspectList,
		deletedKSK2021_R01InspectList, setDeletedKSK2021_R01InspectList, addDeletedKSK2021_R01InspectList, removeDeletedKSK2021_R01InspectList,
		selectedKSK2021_R01InspectList, setSelectedKSK2021_R01InspectList, addSelectedKSK2021_R01InspectList, removeSelectedKSK2021_R01InspectList,
		originalKSK2021_R01InspectList, setOriginalKSK2021_R01InspectList,
		allCount, setAllCount,
		notProductResult, setNotProductResult,
		modalVisible, setModalVisible,
		workTimeModalVisible, setWorkTimeModalVisible,
		workTimeModalType, setWorkTimeModalType,
		initData, 
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
	} = useKSK2021_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { company, userInfo } = useUserStore();
	const { printBulkItemLabel } = useItemQzPrint();

	type ProductWorkNav = { productWorkNo: string } | null;
	const navigationDataRef = useRef<ProductWorkNav>(null);
	const [productWorkTrigger, setProductWorkTrigger] = useState(false);

	var Inko = require('inko');
	const inko = new Inko(inkoNpmOption);
	const productWorkInfoHandleFoucsId = 'inputProductWorkNo_search';

	useFetchActionbarAuth("KSK2021_R01");

	
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'productWorkNo',
			category: '공정지시',
			focusId: productWorkInfoHandleFoucsId,
			responseMapping: {
				productWorkNo: 'productWorkNo',
			},
			searchFunction: async (code: string) => {
				const productWorkResponse = await getProductWorkList(code);
				return productWorkResponse.data.data.find(value => value.productWorkNo === code);
			},
			onAfterConfirm: () => {
				setProductWorkTrigger(true);
			},
		}
	];

	const handlePrintClick = async () => {
		if (!editKSK2021_R01 || !editKSK2021_R01.productWorkNo) {
				showWarning("출력할 생산실적번호를 선택하세요.");
				setMessage("출력할 생산실적번호를 선택하세요.");
				return;
			}
			try {
				await printKSK2021_R01(editKSK2021_R01.productWorkNo);
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			}
		};
	

	const handleExcelClick = useCallback(async () => {
		if (!editKSK2021_R01) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK2021_R01('', editKSK2021_R01.productWorkNo, KSK2021_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [editKSK2021_R01])

	const getParams = (filter: KSK2021_R01Filter) => {
		const params: Partial<KSK2021_R01Filter> = {
			labelPrintAuto: filter.labelPrintAuto || undefined,
		};
		return params;
	}

	// const renewalAllCount = useCallback(async () => {
	// 	const response = await getKSK2021_R01AllCount(getParams(KSK2021_R01Filter));
	// 	setAllCount(response.data.data);
	// 	return response.data.data;
	// }, [KSK2021_R01Filter, setAllCount]);

	// const fetchData = useCallback(async () => {
	// 	setLoadingSpinner(true);		
	
	// 	const responseData = (await getKSK2021_R01List(
	// 		'',
	// 		getParams(KSK2021_R01Filter),
	// 		KSK2021_R01List.length ?? 0
	// 	));


	// 	let newList = [...responseData.data.data ] as KSK2021_R01HeaderDto[];
	// 	setKSK2021_R01List(newList);

	// 	const processAllCount = await renewalAllCount();
	// 	if (newList && newList.length > 0) {
	// 		gridRefSelectedRowHandler(
	// 			gridRef,
	// 			setEditKSK2021_R01 || undefined,
	// 			() => true,// () => !responseData.find(value => value.salBillNo === selectedKSK2021_R01?.salBillNo)
	// 		);
	// 		setKSK2021_R01PastFilter(KSK2021_R01Filter);
	// 		ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
	// 	}else {
	// 		showWarning('데이터가 없습니다.');
	// 		setSelectedKSK2021_R01(undefined);
	// 		setKSK2021_R01List([]);
	// 		setKSK2021_R01LotList([]); 
	// 		setDeletedKSK2021_R01LotList([]);
	// 		setSelectedKSK2021_R01LotList([]);
	// 		setOriginalKSK2021_R01LotList([]);
	// 	}
	// 	setLoadingSpinner(false);
	// 	return responseData;
	// }, [KSK2021_R01Filter, KSK2021_R01List, setKSK2021_R01List, setKSK2021_R01PastFilter, setSelectedKSK2021_R01, selectedKSK2021_R01])

	const fetchOne = useCallback(async () => {
		if (!editKSK2021_R01?.productWorkNo) { 
			showWarning('조회할 공정지시번호를 선택하세요.'); 
			getProductWorkFieldHandlers('productWorkNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return; 
		}
		setLoadingSpinner(true);

		const response = await getKSK2021_R01One(editKSK2021_R01?.productWorkNo || '');
		
		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			getProductWorkFieldHandlers('productWorkNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: editKSK2021_R01?.productWorkNo } } as unknown as React.MouseEvent<HTMLInputElement>);
			setLoadingSpinner(false);
			return;
		}

		const workPlaceInfo = workPlaceList.find(value => value.workplaceCd === response.data.data?.workplaceCd);

		let logicCenter = wmsCdList.filter(value => value.minorCd === workPlaceInfo?.logicCenter)[0].minorCd;
		let defaultInWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.productYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultOutWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.materialYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultBadWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		);
		let inWarehouseCd = defaultInWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.inWarehouse));
		let outWarehouseCd = defaultOutWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.outWarehouse));
		let badWarehouseCd = defaultBadWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.badWarehouse));

		// console.log('작업지시정보의 logicCenter :', logicCenter);
		// console.log('작업지시정보의 inWarehouseCd :', inWarehouseCd, ' > ', '작업지시정보의 outWarehouseCd :', outWarehouseCd);

		response.data.data.logicCenter = logicCenter || wmsCdList[0]?.minorCd || '';
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : (inWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : (outWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : (badWarehouseCd[0]?.warehouseCd ?? '');

		setEditKSK2021_R01(response.data.data);

		setLoadingSpinner(false);
		return response.data.data as KSK2021_R01HeaderDto;
	}, [editKSK2021_R01, setEditKSK2021_R01, setLoadingSpinner, workPlaceList, wmsCdList, warehouseCdList, warehouseCdList]);
	
	const defaultKSK2021_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdListToUseList(logicCenter);
		const outWarehouseCdListToUse = outWarehouseCdListToUseList(logicCenter);
		const badWarehouseCdListToUse = badWarehouseCdListToUseList(logicCenter);

		const commonResult = validateCommonCodeLists([
			...buildCommonCodeRequirements(KSK2021_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				workPlaceList,
				wmsCdList,
				itemStatusList,
				warehouseCdList,
			}),
			{
				key: 'productWarehouseList',
				list: warehouseCdListToUse,
				message: KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'outWarehouseList',
				list: outWarehouseCdListToUse,
				message: KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'badWarehouseList',
				list: badWarehouseCdListToUse,
				message: KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
			},
		]);

		if (!commonResult.valid) {
			return { ...defaultKSK2021_R01HeaderDto };
		}

		return {
			...defaultKSK2021_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			outWarehouseCd: outWarehouseCdListToUse[0].warehouseCd,
			badWarehouseCd: badWarehouseCdListToUse[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		compCdList,
		workPlaceList,
		wmsCdList,
		itemStatusList,
		warehouseCdList,
		warehouseCdListToUseList,
		outWarehouseCdListToUseList,
		badWarehouseCdListToUseList,
		validateCommonCodeLists,
	]);

	const defaultKSK2021_R01DetailRow = useCallback(() => ({
		...defaultKSK2021_R01DetailDto,
		inserted: true,
	}), [defaultKSK2021_R01DetailDto]);

	const defaultKSK2021_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK2021_R01_INSPECT_ROW_VALIDATE, { faultyValueList }),
		);

		if (!commonResult.valid) {
			return { ...defaultKSK2021_R01InspectDto };
		}

		return {
			...defaultKSK2021_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [faultyValueList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		setEditKSK2021_R01(defaultKSK2021_R01HeaderRow());
		setKSK2021_R01Filter({ ...KSK2021_R01Filter, labelPrintAuto: company?.labelPrintAuto || 'N' });
	}, [company, defaultKSK2021_R01HeaderRow, initData, KSK2021_R01Filter, setEditKSK2021_R01, setKSK2021_R01Filter]);

	const handleDeleteClick = useCallback(() => {

		// 비가동 - 불량내역 삭제 기능으로 변경하기
		if (deletedKSK2021_R01InspectList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구

			removeDeletedKSK2021_R01InspectList(deletedKSK2021_R01InspectList);
			removeSelectedKSK2021_R01InspectList();
			setKSK2021_R01InspectList([...KSK2021_R01InspectList]);

		} else if (selectedKSK2021_R01InspectList.length > 0) {

			addDeletedKSK2021_R01InspectList(selectedKSK2021_R01InspectList);
			removeSelectedKSK2021_R01InspectList(selectedKSK2021_R01InspectList);
		}

	}, [
		selectedKSK2021_R01InspectList, deletedKSK2021_R01InspectList, setKSK2021_R01InspectList, KSK2021_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		const headerRow = defaultKSK2021_R01HeaderRow();
		if (!headerRow.inserted) return;

		const inspectRow = defaultKSK2021_R01InspectRow();
		if (!inspectRow.inserted) return;

		setEditKSK2021_R01({ ...headerRow });

		setKSK2021_R01InspectList([{ ...inspectRow }]);
		setDeletedKSK2021_R01InspectList([]);
		setSelectedKSK2021_R01InspectList([]);
		setOriginalKSK2021_R01InspectList([]);
	}

	const getProductResultHeaderDto = (header: KSK2021_R01HeaderDto) => {
		return {
			...header,
			kpiYn: 'N',
			productEmp: header.workEmp,
			productEmpNm: header.workEmpNm,
			badWarehouseCd: header.badWarehouseCd,
			inspectQty: 0,
			inspectYn: 'N',
			workStartDt: toLocalDateTime(new Date()),
			workEndDt: undefined,
		} as KSK2021_R01ProductResultDto;
	}

	const validateInsertData = (
		header: KSK2021_R01HeaderDto,
		detailList: KSK2021_R01DetailDto[],
		inspectList: KSK2021_R01InspectDto[],
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(header.productWorkNo)) {
			showWarning('지시No를 입력해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!itemCdMap.has(header.itemCd)) {
			showWarning('품목코드가 존재하지 않습니다.' + warningMessage); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.workEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(header.workEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if ((header.productQty || 0) <= 0) {
			showWarning('생산양품량을 입력해주세요.'); return false;
		}
		if (Number(header.productQty) + Number(header.badQty) > Number(header.orderQty)) {
			if (header.fromTime == null || header.toTime == null) {
				showWarning('생산양품량과 불량수량의 합이 지시잔량을 초과하는 경우, 작업 시작시간과 종료시간을 등록해주세요.');
				return false;
			}
		}

		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}
		}
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedKSK2021_R01InspectList.map(value => Number(value));
			const activeInspectList = inspectList.filter(inspect => 
				!deletedInspectListToNumber.includes(inspect.valueIndex)
			);

			const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);
			const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			
			if (duplicates.length > 0) {
				showWarning("중복된 불량사유가 있습니다.\n불량사유: " + badCaseNames.join(', '));
				return false;
			}
		}
		
		return true;
	}
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editKSK2021_R01!, KSK2021_R01DetailList, KSK2021_R01InspectList)) valid = false;
		if(!valid) { return; }
		setLoadingSpinner(true);
		
		let unprintedLabelData: ItemLabelPrintData[] = [];
		if(KSK2021_R01Filter.labelPrintAuto === 'Y') {
			const store = useKSK2021_R01Store.getState();
			unprintedLabelData = KSK2021_R01_extractUnprintedItemLabelData(store);
		}
		
		let processName = '';
		let newHeaderList: KSK2021_R01HeaderDto[] = [];
		let responseData: KSK2021_R01Dto = {
			productWorkHeaderDto: editKSK2021_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editKSK2021_R01!),
			wmsStockLotDtoList: [],
			bomDtoList: KSK2021_R01DetailList,
			prdInspectResultDtoList: KSK2021_R01InspectList,
		};
		let deleteHeaderFlag = false;

		try {
			if (editKSK2021_R01) {
				processName = 'patch';

				const deletedKSK2021_R01InspectList_Number = deletedKSK2021_R01InspectList.map(value => Number(value));
				const patchResponse = await patchKSK2021_R01({
					productWorkHeaderDto: editKSK2021_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editKSK2021_R01!),
					wmsStockLotDtoList: [],
					bomDtoList: KSK2021_R01DetailList,
					prdInspectResultDtoList: KSK2021_R01InspectList.filter(value => (
							!deletedKSK2021_R01InspectList_Number.includes(value.valueIndex) 
							&& validateString(value.badCase)
						)
					),
				});

				responseData = patchResponse.data.data;

				const responseProductWorkHeaderDto = {
					...responseData.productWorkHeaderDto,
					resultQty: responseData.productWorkHeaderDto.resultQty,
					orderQty: responseData.productWorkHeaderDto.orderQty - responseData.productWorkHeaderDto.resultQty
				};

				newHeaderList = KSK2021_R01List.map(value => {
					if (value.productWorkNo === responseData.productWorkHeaderDto.productWorkNo) {
						return responseProductWorkHeaderDto;
					}
					return value;
				});
				if (editKSK2021_R01!.productQty >= editKSK2021_R01!.orderQty) {
					newHeaderList = KSK2021_R01List.filter(value => value.productWorkNo !== responseData.productWorkHeaderDto.productWorkNo);	
					deleteHeaderFlag = true;
				}
				
				if (patchResponse?.data?.data && patchResponse.data.successFlag) {
					showSuccess('생산실적이 등록되었습니다.');
					setMessage('생산실적이 등록되었습니다.');
				}else {
					showWarning('생산실적 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			} else {
				processName = 'post';
				const postResponse = await postKSK2021_R01({
					productWorkHeaderDto: editKSK2021_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editKSK2021_R01!),
					wmsStockLotDtoList: [],
					bomDtoList: KSK2021_R01DetailList,
					prdInspectResultDtoList: KSK2021_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseProductWorkHeaderDto = {
					...responseData.productWorkHeaderDto,
					orderQty: responseData.productWorkHeaderDto.orderQty - responseData.productWorkHeaderDto.resultQty,
					resultQty: responseData.productResultHeaderDto.productQty
				};

				newHeaderList = [
					...KSK2021_R01List,
					responseProductWorkHeaderDto,
				] as KSK2021_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록되었습니다.');
					setMessage('생산실적이 등록되었습니다.');
				}else {
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setKSK2021_R01List(newHeaderList);

			setEditKSK2021_R01({ ...defaultKSK2021_R01HeaderDto, })
			setKSK2021_R01DetailList([]);

			setSelectedKSK2021_R01DetailList([]);
			setOriginalKSK2021_R01DetailList([]);
			setDeletedKSK2021_R01DetailList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setKSK2021_R01List(newHeaderList);

			const newEditKSK2021_R01 = {
				...responseData.productWorkHeaderDto,
				orderQty: responseData.productWorkHeaderDto.orderQty - responseData.productWorkHeaderDto.resultQty,
				itemStatus: responseData.productResultHeaderDto.itemStatus || itemStatusList[0]?.minorCd || '',
				productDt: responseData.productResultHeaderDto.productDt || formatDate(new Date()),
				logicCenter: responseData.productResultHeaderDto.logicCenter || '',
				warehouseCd: responseData.productResultHeaderDto.warehouseCd || '',
				outWarehouseCd: responseData.productResultHeaderDto.outWarehouseCd || '',
				badWarehouseCd: responseData.productResultHeaderDto.badWarehouseCd || '',
				productQty: 0,
				badQty: 0,
			};

			setEditKSK2021_R01(newEditKSK2021_R01);
			
			const aggregatedResponseBomList = aggregateKSK2021_R01DetailList(responseData.bomDtoList);
			const newDetailList = KSK2021_R01DetailList.filter(
				value => findAggregatedDetailItem(aggregatedResponseBomList, value) != null,
			).map(value => {
				const matched = findAggregatedDetailItem(aggregatedResponseBomList, value);
				return {
					...value,
					...matched,
					childItemUsage: value.childItemUsage,
					coordinateUsage: value.coordinateUsage ?? value.childItemUsage,
					bomUsingQty: 0,
					transportQty: 0,
					isModified: false,
				};
			});
			setKSK2021_R01DetailList(newDetailList);
			setOriginalKSK2021_R01DetailList(newDetailList);
		}

		setSelectedKSK2021_R01DetailList([]);

		setKSK2021_R01InspectList([defaultKSK2021_R01InspectRow()]);
		setSelectedKSK2021_R01InspectList([]);
		setDeletedKSK2021_R01InspectList([]);
		setOriginalKSK2021_R01InspectList([]);

		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	
		if (
			KSK2021_R01Filter.labelPrintAuto === 'Y'
			&& unprintedLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				await printBulkItemLabel(unprintedLabelData);
				showSuccess(`저장 완료! ${unprintedLabelData.length}개 품목 라벨 출력`);
			} catch (error: any) {
				console.error('품목 라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
			}
		}
	
	}, [
		KSK2021_R01Filter.labelPrintAuto,
		editKSK2021_R01, 
		KSK2021_R01DetailList, 
		KSK2021_R01InspectList, deletedKSK2021_R01InspectList,
		KSK2021_R01List, setKSK2021_R01List,
		defaultKSK2021_R01InspectRow,
		printBulkItemLabel,
	]);

	const getServerMessage = useCallback((error: unknown) => {
		const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
		return serverMessage || '작업종료등록 중 오류가 발생했습니다.';
	}, []);
	
	//time 정보가 있고, 1900-01-01T00:00:00+09:00 과 비교해서 아닐시 false, 맞으면 true
	const validateWorkStartEnd = useCallback((time: string | undefined) => {

		if (time === undefined) {
			return false;
		}

		// time이 문자열로 들어올 경우를 대비해 Date 객체로 변환 후 getTime 호출
		const targetDate = new Date(time);

		if (
			targetDate.getTime() !== new Date(defaultValidateDateString).getTime()
		) {
			return false;
		}
		return true;
	}, []);

	const handleWorkTimeClick = useCallback(async (productWorkNo: string, processType: KSK2021_R01WorkTimeProcessType, manualTime?: Date, rawTime?: { month: string, day: string, hour: string, minute: string }) => {
		if(!validateString(productWorkNo)) { showWarning('공정지시 번호를 입력하세요.'); return false; }

		const isReset = processType === 'workStartReset' || processType === 'workEndReset';

		if (!isReset && rawTime) {
			const m = Number(rawTime.month);
			const d = Number(rawTime.day);
			const h = Number(rawTime.hour);
			const min = Number(rawTime.minute);

			if (isNaN(m) || m < 1 || m > 12) { showWarning('월은 1~12월 사이로 입력해주세요.'); return false; }
			if (isNaN(d) || d < 1 || d > 31) { showWarning('일은 1~31일 사이로 입력해주세요.'); return false; }
			if (isNaN(h) || h < 0 || h > 23) { showWarning('시는 0~23 사이로 입력해주세요.'); return false; }
			if (isNaN(min) || min < 0 || min > 59) { showWarning('분은 0~59분 사이로 입력해주세요.'); return false; }
		}

		const isStart = processType === 'workStart' || processType === 'workStartReset';
		const timeField = isStart ? 'fromTime' : 'toTime';
		const modalType = isStart ? 'start' : 'end';
		const successMsg = isReset
			? (isStart ? '작업시작 초기화에 성공하였습니다.' : '작업종료 초기화에 성공하였습니다.')
			: (isStart ? '작업시작에 성공하였습니다.' : '작업종료에 성공하였습니다.');
		const failMsg = isReset
			? (isStart ? '작업시작 초기화에 실패하였습니다.' : '작업종료 초기화에 실패하였습니다.')
			: (isStart ? '작업시작에 실패하였습니다.' : '작업종료에 실패하였습니다.');
		const apiCall = isStart ? patchKSK2021_R01WorkStart : patchKSK2021_R01WorkEnd;

		let targetTime: Date;
		if (isReset) {
			// 초기화는 UTC 기준 Date로 생성해 JSON 직렬화 시 1900-01-01T00:00:00.000Z로 전송합니다.
			targetTime = new Date(defaultValidateDateString);
		} else if (manualTime) {
			targetTime = manualTime;
		} else {
			// 시간이 없으면 현재 로컬 시간을 사용
			targetTime = new Date();
            // targetTime.setHours(targetTime.getHours() + 9);
			if(!validateWorkStartEnd(editKSK2021_R01?.[timeField] || undefined)) { 
				setWorkTimeModalType(modalType);
				setWorkTimeModalVisible(true);
				return false;
			}
		}

		try {
			const responseData = (await apiCall(productWorkNo, toLocalDateTime(targetTime))).data;
			if(responseData && responseData.successFlag) {
				showSuccess(successMsg);
				setMessage(successMsg);
				setEditKSK2021_R01({ ...editKSK2021_R01!, [timeField]: responseData.data[timeField] });
				return true;
			}else {
				showWarning(failMsg);
				return false;
			}
		} catch (error) {
			console.error(`${isStart ? '작업시작' : '작업종료'}등록 중 오류가 발생했습니다.:`, error);
			showError(getServerMessage(error));
			return false;
		}
	}, [editKSK2021_R01]);

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: KSK2021_R01HeaderDto): Partial<KSK2021_R01HeaderDto> => {
		const defaults: Partial<KSK2021_R01HeaderDto> = {};
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y' )
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		defaults.itemStatus = validateString(headerData.itemStatus) ? headerData.itemStatus : (itemStatusList[0]?.minorCd ?? '');

		defaults.workEmp = headerData.workEmp ? headerData.workEmp : (employeeCdList[0]?.empNo ?? '');
		defaults.workEmpNm = headerData.workEmpNm ? headerData.workEmpNm : (employeeCdList[0]?.empNm ?? '');

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
		defaults.productQty = headerData.productQty ? headerData.productQty : 0;
	
		return defaults;
	}, [editKSK2021_R01, compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList])

	const handleFetchBomProductList = useCallback(async (productWorkNo: string, itemCd: string, outWarehouseCd: string, logicCenter: string ) => {
		const responseData = (await getKSK2021_R01DetailStockList(productWorkNo, itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){
			const aggregatedStockList = aggregateKSK2021_R01DetailList(
				normalizeKSK2021_R01DetailList(responseData),
			);

			const currentDetailList = useKSK2021_R01Store.getState().KSK2021_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = findAggregatedDetailItem(aggregatedStockList, value);
				return {
					...value,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setKSK2021_R01DetailList(updatedDetails);
			setOriginalKSK2021_R01DetailList(aggregatedStockList);
			setMessage(`상세내역 ${aggregatedStockList.length}건을 조회하였습니다.`);
		} else {
			setOriginalKSK2021_R01DetailList([]);
		}
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setTimeout(() => setMessage(""), 5000);


	}, [editKSK2021_R01?.itemCd, editKSK2021_R01?.warehouseCd, editKSK2021_R01?.logicCenter, wmsCdList, setKSK2021_R01DetailList, setOriginalKSK2021_R01DetailList, setMessage])


	
	// input form 팝업 열기 이벤트 핸들러
	const { getFieldHandlers: getProductWorkFieldHandlers } = useInfoFormEvents({
		editData: editKSK2021_R01,
		setEditData: setEditKSK2021_R01,
		defaultData: { ...defaultKSK2021_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2021_R01'
	});

	const handleFetchLotList = useCallback(() => {
		if(!validateString(editKSK2021_R01?.productWorkNo || '')) {
			// showWarning('공정지시 번호를 입력하세요.');
			getProductWorkFieldHandlers('productWorkNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return;
		}
		
		const fetchDetailList = async (productWorkNo: string, itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string, workplaceCd: string) => {
			try {
				const response = await getKSK2021_R01DetailList(productWorkNo, itemCd, productQty, badQty, outWarehouseCd, logicCenter, workplaceCd);
				
				if (response.data && response.data.successFlag === false) {
					// showWarning(response.data.message);
					setKSK2021_R01DetailList([]);
					return;
				}

				const responseData = response.data.data;
				if(responseData && responseData.length > 0){
					const normalizedList = normalizeKSK2021_R01DetailList(responseData);
					const aggregatedDetailList = aggregateKSK2021_R01DetailList(normalizedList);
					setKSK2021_R01DetailList(aggregatedDetailList);
					setOriginalKSK2021_R01DetailList(aggregatedDetailList);
					detailGridRef.current?.api.ensureIndexVisible(0, 'top');
					setMessage(`자재출고 ${aggregatedDetailList.length}건을 조회하였습니다. (LOT ${responseData.length}건 취합)`);
					setTimeout(() => setMessage(""), 5000);
				}else{
					// showError('상세내역이 없습니다.');
					// 자재출고 내역은 데이터가 없으면 보여주지 말기
					setKSK2021_R01DetailList([]);
				}
			} catch (error) {
				console.error(error);
				setKSK2021_R01DetailList([]);
			}
			return;
		}

		//생산결과가 있는 공정지시 정보 조회
		//공정지시번호의 작업지시번호로 생산결과 조회
		const fetchProductResult = async (headerData: KSK2021_R01HeaderDto) => {

			let apiHeaderData: KSK2021_R01ProductResultDto | null = null;
			try {
				const transportResponse = await getKSK2021_R01ProductResultList(headerData.productOrderNo!, headerData.productWorkNo!);
				apiHeaderData = transportResponse.data.data;
				
				let baseDataForDefaults;
				if (apiHeaderData && apiHeaderData.productResultNo) {
					setNotProductResult(false);
					baseDataForDefaults = { 
						...defaultKSK2021_R01HeaderDto,
						...headerData,
						...apiHeaderData,
						// orderQty: headerData.orderQty - headerData.resultQty,
						productQty : 0,
						badQty : 0, // 불량수량 0 고정(초기화)
						itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : (itemStatusList[0]?.minorCd ?? ''),
					};
				} else {
					setNotProductResult(true);
					baseDataForDefaults = { 
						...defaultKSK2021_R01HeaderDto,
						...headerData,
					};
				}
				

				const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

				setEditKSK2021_R01({	
					...baseDataForDefaults,
					...defaultValues,
				});

			} catch (error) {
				console.error("ProductResult 내역 조회 실패:", error);
				setNotProductResult(true);
			}

			if(apiHeaderData && apiHeaderData.productResultNo) {
				return apiHeaderData;
			} else {
				return null;
			}
		}

		
		setKSK2021_R01DetailList([]);
		setKSK2021_R01InspectList([]);

		const fetchAllData = async () => {
			if (validateString(editKSK2021_R01?.productWorkNo || '')) {

				const headerData = await fetchOne();
				if(!headerData) return;
				// console.log('headerData :', headerData);

				const productResult: KSK2021_R01ProductResultDto | null = await fetchProductResult(headerData);
				if(productResult && productResult.productResultNo !== '') {

					await fetchDetailList(
						headerData.productWorkNo,
						productResult?.itemCd || '',
						productResult?.productQty ?? 0,
						productResult?.badQty ?? 0,
						headerData.outWarehouseCd,
						headerData.logicCenter,
						headerData.workplaceCd
					);
				}else{
					await fetchDetailList(
						headerData.productWorkNo,
						headerData?.itemCd || '',
						0,
						0,
						headerData.outWarehouseCd,
						headerData.logicCenter,
						headerData.workplaceCd
					);

				}

				//  header의 창고정보, 물류정보를 정의해서 자재출고 항목에 창고정보, 물류정보를 업데이트
				if (productResult && productResult.productResultNo !== '') {

					await handleFetchBomProductList(
						headerData.productWorkNo,
						productResult.itemCd,
						headerData.outWarehouseCd,
						productResult.logicCenter || (editKSK2021_R01?.logicCenter ?? wmsCdList[0].minorCd)
					);
				}
				setKSK2021_R01InspectList([]);
				insertKSK2021_R01InspectList([defaultKSK2021_R01InspectRow()])
			}
		};

		fetchAllData();


	}, [editKSK2021_R01])

	// KSK2010_R01에서 전달받은 데이터로 자동 조회
	useEffect(() => {
		
		if (productWorkNavigationData) {
			
			// 네비게이션 데이터를 ref에 저장
			navigationDataRef.current = productWorkNavigationData;

			// editKSK2021_R01의 productWorkNo를 생산실적번호로 설정
			setEditKSK2021_R01({ ...editKSK2021_R01!, productWorkNo: productWorkNavigationData.productWorkNo || '' } as KSK2021_R01HeaderDto);
			setProductWorkTrigger(true);
			
			setProductWorkNavigationData(null);
		}
	}, [productWorkNavigationData, setProductWorkNavigationData]);

	//productOrderTrigger true이면 handleFetchLotList를 호출
	// navigationDataRef(타화면 이동) 또는 editKSK2021_R01(모달/엔터 직접입력) 둘 중 하나에 productWorkNo가 있으면 실행
	useEffect(() => {
		const workNo = navigationDataRef.current?.productWorkNo || editKSK2021_R01?.productWorkNo || '';
		if (productWorkTrigger && validateString(workNo)) {
			handleFetchLotList();
			setProductWorkTrigger(false);
		}
	}, [productWorkTrigger]);


	
	useEffect(() => {
		if (company) {
			setKSK2021_R01Filter({ ...KSK2021_R01Filter, labelPrintAuto: company.labelPrintAuto });
		}
	}, [company, setKSK2021_R01Filter]);
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchOne,
		defaultKSK2021_R01HeaderRow,
		defaultKSK2021_R01DetailRow,
		defaultKSK2021_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		validateWorkStartEnd,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
	};
}
